import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useOutletContext } from "react-router-dom";
// components
import FormMessage from "../../components/FormMessage";
import SectionLoader from "../../components/SectionLoader";
import { CustomInput } from "@gl-shared/shared/ui";
import { CustomFormInput } from "@gl-shared/shared/ui";
import { CustomButton } from "@gl-shared/shared/ui";
// helpers
import { appSection, getHotelData } from "../../common/utils/panel-helpers/helpers";
import { checkForEmptyField, checkForValidEmail } from "@gl-shared/shared/helpers";
// actions
import { settingsActionCreators } from "../../common/store/modules/settingsModule";
import { homeActionCreators } from "../../common/store/modules/homeModule";

const Settings = props => {
  const [hotelName, setHotelName] = useState("");
  const [hotelStreet, setHotelStreet] = useState("");
  const [hotelStreetNumber, setHotelStreetNumber] = useState("");
  const [hotelZIP, setHotelZIP] = useState("");
  const [hotelCity, setHotelCity] = useState("");
  const [hotelEmail, setHotelEmail] = useState("");
  const [hotelWebsite, setHotelWebsite] = useState("");
  const [hotelPhone, setHotelPhone] = useState("");
  const [sendBookingConfirmationCopy, setSendBookingConfirmationCopy] = useState(false);
  const selectedHotelData = getHotelData(props.isHotelGroupExists, props.selectedHotels[0], props.hotelData);
  const [errorField, setErrorField] = useState({
    name: false,
    street: false,
    streetNumber: false,
    zip: false,
    city: false,
    email: false,
    website: false,
    phone: false
  });

  const outletContext = useOutletContext();

  useEffect(() => {
    // call loadSettings initially (after we get hotel-info data) and on every hotel change
    if (props?.hotelData?.hotelUserId) {
      outletContext.loadSettings(props.selectedHotels[0]?.id);
    }
  }, [props.selectedHotels[0]?.id, props.hotelData]);

  useEffect(() => {
    fillInInputsFromSettingsData();
  }, [props.hotelSettingsData?.name]);

  useEffect(() => {
    setSendBookingConfirmationCopy(!!selectedHotelData?.account_settings?.send_booking_confirmation_copy);
  }, [selectedHotelData]);

  const fillInInputsFromSettingsData = () => {
    setHotelName(props.hotelSettingsData?.name || "");
    setHotelStreet(props.hotelSettingsData?.address?.street || "");
    setHotelStreetNumber(props.hotelSettingsData?.address?.house_number || "");
    setHotelZIP(props.hotelSettingsData?.address?.zip_code || "");
    setHotelCity(props.hotelSettingsData?.address?.city || "");
    setHotelEmail(props.hotelSettingsData?.email || "");
    setHotelWebsite(props.hotelSettingsData?.website || "");
    setHotelPhone(props.hotelSettingsData?.address?.phone_number || "");
  };

  const handleSubmit = async () => {
    let errorCheck = true;
    let errorField = {
      name: false,
      street: false,
      streetNumber: false,
      zip: false,
      city: false,
      email: false,
      website: false,
      phone: false
    };

    if (hotelName === "") {
      errorCheck = false;
      errorField.name = true;
    }
    if (hotelStreet === "") {
      errorCheck = false;
      errorField.street = true;
    }
    if (hotelStreetNumber === "") {
      errorCheck = false;
      errorField.streetNumber = true;
    }
    if (hotelZIP === "") {
      errorCheck = false;
      errorField.zip = true;
    }
    if (hotelCity === "") {
      errorCheck = false;
      errorField.city = true;
    }
    if (checkForEmptyField(hotelEmail) || checkForValidEmail(hotelEmail)) {
      errorCheck = false;
      errorField.email = true;
    }
    if (hotelWebsite === "") {
      errorCheck = false;
      errorField.website = true;
    }
    if (hotelPhone === "") {
      errorCheck = false;
      errorField.phone = true;
    }
    setErrorField(errorField);

    if (errorCheck === false) {
      return false;
    }

    props.setAccountSettingsDataAction({
      ...selectedHotelData?.accountSettings,
      sendBookingConfirmationCopy: sendBookingConfirmationCopy
    });

    props.updateSettingsAction(
      hotelName,
      hotelWebsite,
      hotelEmail,
      hotelStreet,
      hotelStreetNumber,
      hotelZIP,
      hotelCity,
      hotelPhone,
      null,
      null,
      null,
      outletContext.handleFormMessage,
      outletContext.loadSettings
    );
  };

  return (
    <div className="employees component">
      {props.sectionLoadingNames === null || props.sectionLoadingNames?.includes(appSection?.hotelSettings) ? (
        <SectionLoader loadingLabel="LOADING SETTINGS" />
      ) : (
        <>
          {props.formData?.form === "Settings" ? (
            <FormMessage
              form={props.formData?.form}
              formError={props.formData?.formError}
              formSuccessful={props.formData?.formSuccessful}
            />
          ) : null}
          {props.formData?.form === "HotelSelectionNotice" && (
            <FormMessage form={props.formData?.form} hotelName={props.formData?.hotelName} />
          )}
          <div className="row">
            <div className="col-lg-8">
              <div className="ibox form__ibox">
                <div className="ibox-title">
                  <h5>Hotel Settings</h5>
                </div>
                <div className="ibox-content">
                  <div>
                    <CustomFormInput
                      showTooltip={false}
                      name="hotelName"
                      id="name"
                      label="Hotel Name"
                      onInputChange={event => setHotelName(event.target.value)}
                      errorField={errorField}
                      isRequired={true}
                      value={hotelName}
                    />

                    <div className="form-group  row">
                      <label className="col-sm-4 col-form-label settings__label field--required">Street & Number</label>
                      <div className="col-sm-6">
                        <CustomInput
                          showLabel={false}
                          name="hotelStreet"
                          id="street"
                          onInputChange={event => setHotelStreet(event.target.value)}
                          errorField={errorField}
                          isRequired={true}
                          value={hotelStreet}
                        />
                      </div>
                      <div className="col-sm-2">
                        <CustomInput
                          showLabel={false}
                          name="hotelStreetNumber"
                          id="streetNumber"
                          onInputChange={event => setHotelStreetNumber(event.target.value)}
                          errorField={errorField}
                          isRequired={true}
                          value={hotelStreetNumber}
                        />
                      </div>
                    </div>
                    <div className="form-group  row">
                      <label className="col-sm-4 col-form-label settings__label field--required">ZIP & City</label>
                      <div className="col-sm-3">
                        <CustomInput
                          showLabel={false}
                          name="hotelZIP"
                          id="zip"
                          onInputChange={event => setHotelZIP(event.target.value)}
                          errorField={errorField}
                          isRequired={true}
                          value={hotelZIP}
                        />
                      </div>
                      <div className="col-sm-5">
                        <CustomInput
                          showLabel={false}
                          name="hotelCity"
                          id="city"
                          onInputChange={event => setHotelCity(event.target.value)}
                          errorField={errorField}
                          isRequired={true}
                          value={hotelCity}
                        />
                      </div>
                    </div>

                    <CustomFormInput
                      showTooltip={false}
                      name="hotelEmail"
                      id="email"
                      label="E-Mail"
                      onInputChange={event => setHotelEmail(event.target.value)}
                      errorField={errorField}
                      isRequired={true}
                      value={hotelEmail}
                    />
                    <CustomFormInput
                      showTooltip={false}
                      name="hotelWebsite"
                      id="website"
                      label="Website"
                      onInputChange={event => setHotelWebsite(event.target.value)}
                      errorField={errorField}
                      isRequired={true}
                      value={hotelWebsite}
                    />
                    <CustomFormInput
                      maskedNumberInput={true}
                      maskedPhoneNumber={true}
                      showTooltip={false}
                      name="hotelPhone"
                      id="phone"
                      label="Phone"
                      onInputBlur={value => setHotelPhone(value)}
                      errorField={errorField}
                      isRequired={true}
                      value={hotelPhone}
                    />

                    <div className="form-group  row">
                      <label className="col-sm-4 col-form-label settings__label">
                        Receive copy of booking confirmation e-mail
                      </label>
                      <div className="col-sm-8">
                        <div className="fare__toggle">
                          <label className="switch__toggle">
                            <input
                              type="checkbox"
                              value={sendBookingConfirmationCopy}
                              onChange={() => setSendBookingConfirmationCopy(!sendBookingConfirmationCopy)}
                              checked={sendBookingConfirmationCopy}
                            />
                            <span className="toggle-switch__slider round" />
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="form-group  row settings__submit">
                      <CustomButton
                        isDisabled={false}
                        mainClass="btn-green"
                        customClasses="btn-green--height-l"
                        onClick={handleSubmit}
                        buttonText="SAVE"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  isHotelGroupExists: state.home.isHotelGroupExists,
  selectedHotels: state.global.selectedHotels,
  hotelData: state.home?.hotelData,
  hotelSettingsData: state.settings.hotelSettingsData,
  formData: state.global.formData,
  sectionLoadingNames: state.global.sectionLoadingNames
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      updateSettingsAction: settingsActionCreators.updateSettingsAction,
      setAccountSettingsDataAction: homeActionCreators.setAccountSettingsDataAction
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
